import {createRoot, hydrateRoot} from 'react-dom/client';
import SupplierAndBuyerPortals from '../pages/SupplierAndBuyerPortals/SupplierAndBuyerPortals'
import "../index.css";
import "../pages/SupplierAndBuyerPortals/SupplierAndBuyerPortals.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<SupplierAndBuyerPortals {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <SupplierAndBuyerPortals {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).SupplierAndBuyerPortalsVC = {mount, hydrate, unmount}